module.exports = __webpack_public_path__ + "static/keqing-banner-24fabe05fd4bc31726f110dbc60f9671.png";